import type { EffectRecord } from "@exploitlens/ui-contracts";

import { formatWei, shortHex } from "../../lib/format";
import { EmptyState } from "../shell/EmptyState";

function describe(effect: EffectRecord): { kind: string; detail: string } {
  switch (effect.type) {
    case "native-transfer":
      return {
        kind: "Native transfer",
        detail: `${shortHex(effect.from)} → ${shortHex(effect.to)} · ${formatWei(effect.amountWei)}`,
      };
    case "token-transfer":
      return {
        kind: `${effect.standard} transfer`,
        detail: `${shortHex(effect.from)} → ${shortHex(effect.to)} · ${effect.amount} (${shortHex(effect.token)})`,
      };
    case "event":
      return {
        kind: effect.name ?? "Event",
        detail: shortHex(effect.address),
      };
    case "storage-write":
      return {
        kind: "Storage write",
        detail: `${shortHex(effect.address)} slot ${shortHex(effect.slot)}: ${shortHex(effect.before)} → ${shortHex(effect.after)}`,
      };
  }
}

export function EffectLedger({ title, effects }: { title: string; effects: EffectRecord[] }) {
  return (
    <div>
      <h3 className="text-sm font-medium text-ink-muted">{title}</h3>
      {effects.length === 0 ? (
        <div className="mt-2">
          <EmptyState title="No effects are attributed here." />
        </div>
      ) : (
        <ul className="mt-2 space-y-1.5">
          {effects.map((effect) => {
            const { kind, detail } = describe(effect);
            return (
              <li
                key={effect.id}
                className="rounded border border-rule bg-canvas px-3 py-2 text-sm"
              >
                <span className="text-ink">{kind}</span>
                <span className="ml-2 font-evidence text-xs text-ink-muted">{detail}</span>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
